export default __webpack_public_path__ + "static/media/weatherbg.ae4f667f.jpg";